import { createSingletonStore } from './_singletonStore';

export const prompt = createSingletonStore("prompt");